import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '@env/environment';
import { AuthService } from '@app/core/auth/auth.service';
import { DialogService } from '@app/shared/dialog/dialog.service';
import { RequirePermission } from '@app/core/enums/require-permission.enum';

export const authGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
): boolean => {
    const authService = inject(AuthService);
    const dialogService = inject(DialogService);
    const router = inject(Router);

    if (!environment.authEnabled) {
        return true;
    }

    if (authService.isAuthenticated()) {
        const requiredPermissions = route.data['permissions'] as RequirePermission[];

        // this case, only required authenticated.
        if (!requiredPermissions || requiredPermissions.length === 0) {
            return true;
        }

        // check if user have any permission required
        const havePers = authService.havePermission(requiredPermissions);

        // show alert and navigate to Location page
        if (!havePers) {
            dialogService.open('UnAuthorized', 'You dont have enough permissions!', false)
                .subscribe(() => {
                    router.navigateByUrl('/location-picker');
                });
        }

        return havePers; // required a permission but user doesn't have any permission
    }

    router.navigateByUrl('/login');
    return false;
};
